import { usePedidos } from '../../hooks/usePedidos';
import { Spinner } from '../../components/shared/Spinner';
import { Card } from '../../components/shared/Card';
import { Link } from 'react-router-dom';

function tiempoRelativo(fechaIso: string): string {
  const minutos = Math.round((Date.now() - new Date(fechaIso).getTime()) / 60000);
  if (minutos < 60) return `hace ${minutos} min`;
  const horas = Math.round(minutos / 60);
  if (horas < 24) return `hace ${horas} h`;
  return `hace ${Math.round(horas / 24)} d`;
}

export function DashboardPage() {
  const { data: pendientes, isLoading } = usePedidos('PendienteDeConfirmacion');
  const { data: todos } = usePedidos();

  return (
    <div className="flex flex-col gap-7">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
        <Card className="p-6 flex flex-col gap-1.5">
          <div className="text-xs font-semibold uppercase text-admin-ink-muted">
            Pendientes de confirmación
          </div>
          <div className="text-[32px] font-bold text-terracotta">{pendientes?.length ?? '—'}</div>
        </Card>
        <Card className="p-6 flex flex-col gap-1.5">
          <div className="text-xs font-semibold uppercase text-admin-ink-muted">Pedidos totales</div>
          <div className="text-[32px] font-bold text-wood">{todos?.length ?? '—'}</div>
        </Card>
        <Card className="p-6 flex flex-col gap-1.5">
          <div className="text-xs font-semibold uppercase text-admin-ink-muted">Panel</div>
          <div className="text-[15px] font-semibold text-wood mt-1.5">
            <Link to="/admin/catalogo" className="text-terracotta">
              Gestionar catálogo →
            </Link>
          </div>
        </Card>
      </div>

      <div className="flex flex-col gap-4">
        <h2 className="text-xl font-display font-semibold text-wood">
          Pedidos pendientes de confirmación
        </h2>
        {isLoading ? (
          <Spinner />
        ) : (pendientes ?? []).length === 0 ? (
          <p className="text-admin-ink-muted text-sm">No hay pedidos pendientes por ahora.</p>
        ) : (
          <div className="flex flex-col gap-3">
            {pendientes!.map((pedido) => (
              <Card key={pedido.id} className="flex flex-wrap items-center gap-4 sm:gap-5 px-6 py-5">
                <div className="w-2 h-2 rounded-full bg-[oklch(76%_0.15_65)] shrink-0" />
                <div className="flex-1 min-w-[140px] flex flex-col gap-0.5">
                  <div className="text-sm font-semibold">{pedido.contacto.nombre}</div>
                  <div className="text-xs text-admin-ink-muted">
                    {pedido.contacto.telefono} · {tiempoRelativo(pedido.fechaCreacion)}
                  </div>
                </div>
                <div className="text-[15px] font-bold shrink-0">S/ {pedido.totalPedido.toFixed(2)}</div>
                <Link
                  to={`/admin/pedidos?verDetalle=${pedido.id}`}
                  className="bg-terracotta text-white text-xs font-bold px-5 py-2 rounded-md shrink-0"
                >
                  Ver detalle
                </Link>
              </Card>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
